import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule, MatSnackBarModule, MatInputModule, MatIconModule, MatButtonModule, MatDialogModule, MatDatepickerModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiItemComponent } from './api-item.component';
import { ApiItemService } from './api-item.service';
import { ExtendzApiSelectModule } from '../extendz-api-select/extendz-api-select.module';
import { ApiTableService } from '../api-table/api-table.service';
import { ExtendPipesModule } from '../../common';
import { ExtendzFileUploadModule } from '../../file/';
var ExtendzApiItemModule = /** @class */ (function () {
    function ExtendzApiItemModule() {
    }
    ExtendzApiItemModule = tslib_1.__decorate([
        NgModule({
            imports: [
                CommonModule,
                FlexLayoutModule,
                ReactiveFormsModule,
                //Exentedz
                ExtendPipesModule,
                ExtendzApiSelectModule,
                ExtendzFileUploadModule,
                //Mat
                MatInputModule,
                MatTooltipModule,
                MatSelectModule,
                MatDialogModule,
                MatIconModule,
                MatCardModule,
                MatButtonModule,
                MatSnackBarModule,
                MatDatepickerModule,
                MatMomentDateModule
            ],
            declarations: [ApiItemComponent],
            exports: [ApiItemComponent],
            providers: [ApiTableService, ApiItemService]
        })
    ], ExtendzApiItemModule);
    return ExtendzApiItemModule;
}());
export { ExtendzApiItemModule };
//# sourceMappingURL=extendz-api-item.module.js.map